import { Box, Grid, Typography, Theme } from '@mui/material';
import { InformationDialog, SubHeading } from '../investors/components';
import React, { useEffect, useState } from 'react';
import { Item, ItemDetails, Gridstyles } from './index';
import { Applicant, ApplicationProps } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { SxProps } from '@mui/system';
import { YesNoMaster, applicantStatusMasters } from '../../utils/constant';
import {
  checkYesSelected,
  getAccreditationLabel,
  getQualifiedAccreditations,
  isUsNationality,
} from '../../utils/utilityFunctions';
import { mdmsCountriesList, mdmsDeclarations, nationaliyType } from '../../redux-store/types/mdms';
import { useDispatch } from 'react-redux';
import {
  getDeclarationAccreditorQualifiedStatus,
  getNationalityList,
} from '../../redux-store/actions';

export const KeyValue = ({
  title,
  description,
  amount,
  sx = {},
  descriptionSx = {},
}: {
  title: string | undefined;
  description?: string | number | boolean | null;
  amount?: number | null | undefined | string;
  sx?: SxProps<Theme>;
  descriptionSx?: SxProps<Theme>;
}): JSX.Element => {
  return (
    <Grid item xs={12} sm={6}>
      <Item sx={sx}>{title}</Item>
      <ItemDetails sx={descriptionSx}>
        {' '}
        {description || description === 0 ? description : '-'}
      </ItemDetails>
      {!!amount && amount !== 0 && <Item sx={{ pt: 0 }}> {amount}</Item>}
    </Grid>
  );
};

export const ReadOnlyViewForDeclaration = ({
  applicant,
  declarationAccreditorQualifiedStatus,
}: {
  applicant: Partial<Applicant>;
  declarationAccreditorQualifiedStatus: mdmsDeclarations;
}): JSX.Element => {
  return (
    <>
      <KeyValue
        title={'Accredited Investor'}
        description={YesNoMaster[applicant.isAccreditedInvestor || '']}
      />
      <KeyValue
        title={'Qualified Purchaser Investor'}
        description={YesNoMaster[applicant.qualifiedPurchaserInvestor || '']}
      />
      {checkYesSelected(applicant.isAccreditedInvestor || '') && (
        <>
          <Grid item xs={12} sm={6}>
            <Item>Accredited Investor Status</Item>
            {getQualifiedAccreditations(
              declarationAccreditorQualifiedStatus.Accredited,
              applicant
            ).map((ele) => {
              return (
                <>
                  <ItemDetails>
                    {!applicant.noneOfTheAbove ? '\u2022' : ''} {ele}
                  </ItemDetails>
                </>
              );
            })}
          </Grid>
        </>
      )}
      {checkYesSelected(applicant.qualifiedPurchaserInvestor || '') && (
        <>
          <Grid item xs={12} sm={6}>
            <Item>Qualified Purchaser Status</Item>
            <ItemDetails>
              {getAccreditationLabel(
                declarationAccreditorQualifiedStatus.QualifiedPurchaser || [],
                applicant.qualifiedPurchaserStatus || ''
              )}
            </ItemDetails>
          </Grid>
        </>
      )}
    </>
  );
};

export default function ContributorDetails({
  application,
}: {
  application: Partial<ApplicationProps>;
}): JSX.Element {
  const { applicants = [], modeOfHolding } = application || {};
  const dispatch = useDispatch();
  const [declarationAccreditorQualifiedStatus, setdeclarationAccreditorQualifiedStatus] =
    useState<mdmsDeclarations>({} as mdmsDeclarations);
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);

  useEffect(() => {
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        const DeclarationAccreditorQualifiedStatusMaster = (await dispatch(
          getDeclarationAccreditorQualifiedStatus()
        )) as unknown as mdmsDeclarations;
        setdeclarationAccreditorQualifiedStatus(DeclarationAccreditorQualifiedStatusMaster);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                Contributor Details
              </Typography>
              <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'text.secondary',
                }}>
                Mode of Holding:{' '}
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                    color: 'rgba(0, 0, 0, 0.6)',
                    letterSpacing: '0.4px',
                    ml: 0.5,
                    textTransform: 'capitalize',
                  }}>
                  {modeOfHolding || 'Single'}
                </Typography>
              </Typography>
            </Grid>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First Applicant Details',
                'Second Applicant Details',
                'Third Applicant Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {title}
                  </SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue title={'Name'} description={applicant.name} />
                      <KeyValue title={'Gender'} description={applicant.gender} />
                      <KeyValue
                        title={'Date Of Birth'}
                        description={formatShortDate(applicant.dateOfBirth)}
                      />
                      <KeyValue
                        title={'Father/Spouse Name'}
                        description={applicant.fatherOrSpouseName}
                      />
                      <KeyValue title={'Mother Name'} description={applicant.motherName} />
                      <KeyValue title={'PAN'} description={applicant.panNo} />
                      <KeyValue
                        title={'Status'}
                        description={
                          applicant.status
                            ? applicantStatusMasters[applicant.status]
                            : applicant.status
                        }
                      />
                      <KeyValue title={'Nationality'} description={applicant.nationality} />
                      <KeyValue
                        title={'Tax Resident Of Any Country Other Than India'}
                        description={
                          applicant.taxResidentOfAnyCountryOtherThanIndia === null
                            ? null
                            : applicant.taxResidentOfAnyCountryOtherThanIndia === true
                            ? 'Yes'
                            : 'No'
                        }
                      />
                      {applicant.taxResidentOfAnyCountryOtherThanIndia === true && (
                        <>
                          <KeyValue
                            title={'Tax Country Name'}
                            description={applicant.taxCountryName}
                          />
                        </>
                      )}
                      <KeyValue
                        title={'CVL KRA Verified'}
                        description={applicant.kraVerified}
                        descriptionSx={{
                          textTransform: 'capitalize',
                        }}
                      />
                      <KeyValue
                        title={`AML Verified`}
                        description={applicant.amlCheck ? 'Yes' : 'No'}
                      />
                      {index !== 0 && (
                        <KeyValue
                          title={'RelationShip With First Applicant'}
                          description={applicant.relationShipWithFirstApplicant}
                        />
                      )}
                      {isUsNationality(
                        applicants[index].nationality as string,
                        applicants[index].taxCountryName as string,
                        mdmsCountriesList
                      ) && (
                        <ReadOnlyViewForDeclaration
                          applicant={applicant}
                          declarationAccreditorQualifiedStatus={
                            declarationAccreditorQualifiedStatus
                          }
                        />
                      )}
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
